<template>
  <div class="home">
    <div class="topNews maxWidth" v-if="isRecommend">
      <div class="topNewsCon">
        <div class="topNewsConL">
          <dl v-for="(item, key) in topDadaList.slice(0, 1)" :key="key">
            <router-link :to="typeObj[item.type+'']+'/'+item.type+'/'+item.id">
              <dt>
                <img :src="item.picurl" alt="" />
                <div class="current"></div>
              </dt>
              <dd>
                <h4>{{ item.title }}</h4>
              </dd>
            </router-link>
          </dl>
        </div>
        <div class="topNewsConR">
          <dl v-for="(item, key) in topDadaList.slice(1,5)" :key="key">
            <router-link :to="typeObj[item.type+'']+'/'+item.type+'/'+item.id">
              <dt>
                <img :src="item.picurl" alt="" />
                <div class="current"></div>
              </dt>
              <dd>
                <h4>{{ item.title }}</h4>
              </dd>
            </router-link>
          </dl>
        </div>
      </div>
    </div>
    <div class="maxWidth mod pad" v-for="(item, key) in lanesList" :key="key">
      <h2 class="mod-title">
        <router-link :to="'/laneList/'+'add/' + item.id" class="more" v-if="item.hasDetail == 1"
          >更多></router-link
        >
        <strong>{{ item.title }}</strong>
      </h2>
      <div class="photoThreeCon">
        <dl v-for="(item1, key) in item.data" :key="key">
          <router-link :to="typeObj[item1.type+'']+'/'+item1.type+'/'+item1.id">
            <dt>
              <img :src="item1.picurl" alt="" />
            </dt>
            <dd>
              <h4>{{ item1.title }}</h4>
            </dd>
          </router-link>
        </dl>
      </div>
    </div>
    <!-- <div class="maxWidth ad">
      <router-link to="">
        <img src="../../static/img/file/banner@1165-158.jpg" alt="">
      </router-link>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      topDadaList: [],
      isRecommend:false,
      lanesList: [],
      typeObj:{
        ezfm:"/columnList",
        other:"/columnList",
        recommend:"/detail",
        ezfmHistory:"/detail",
        otherHistory:"/detail",
        more:"/detail",
        lane:"/laneList"
      }
    };
  },
  methods: {
    getList: function () {
      var _this = this;
      _this.$http
        .post(
          "/qertyuiy/v3/classification/detail?id=12&session=8295f0a6-6804-4d61-8944-4f8d60a71cd4"
        )
        .then(function (res) {
          var data = res.data.data;
          if('recommend' in res.data.data){
            _this.isRecommend = true;
            _this.topDadaList = data.recommend;
          }
          _this.lanesList = data.lanes;
          for(var i=0;i<_this.lanesList.length;i++){
            if(_this.lanesList[i].hasDetail == 1){
              _this.lanesList[i].data = _this.lanesList[i].data.slice(0,6);
              
            }
          }

        })
        .catch(function (e) {});
    },
  },
  mounted() {
    this.getList();
  },
};
</script>




// WEBPACK FOOTER //
// src/page/Home.vue